





















































// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";
// project
import { generateGUID } from "@/utils/guid";


type ActionContext = {
	isStart:boolean
};


type CustomAction = {
	icon:string,
	tooltip:string,
	variant:string;
	fn:() => any
};

const testActions:CustomAction[] = [
	{
		tooltip:"Update References",
		variant:"info",
		icon:"mdi.update",
		fn(){
			console.log("Update stuff!");
		}
	},
	{
		icon:"mdi.subdirectory-arrow-right",
		tooltip:"Open",
		variant:"light",
		fn(){
			console.log("Open stuff!");
		}
	}

];


export default defineComponent({

	props:{
		isStart:{
			type:Boolean,
			default:false
		},
		iconSize:{
			type:Number,
			default:0.7
		},
		warningCount:{
			type:Number,
			default:0
		},
		
	},
	components:{
	},
	setup(props, context){
		

		const buttonSize = computed(() => {
			return props.iconSize + 0.6;
		});
		
		const actions = computed(() => {

			const r:any[] = [];
			
			if(props.isStart){
				r.push({
					key:"start-node",
					tooltip:"Start Node",
					variant:"success",
					tooltipVariant:"success",
					icon:"mdi.flag-variant"
				});
			}

			if(props.warningCount > 0){
				r.push({
					key:"warnings",
					tooltip:`${props.warningCount} Warning(s)`,
					variant:"warning",
					tooltipVariant:"warning",
					txtVariant:"danger",
					icon:"mdi.alert-circle"
				});
			}

			testActions.forEach(a => {

				r.push({
					key:generateGUID(),
					tooltip:a.tooltip,
					variant:`outline-${a.variant}`,
					tooltipVariant:a.variant,
					icon:a.icon,
					fn:a.fn
					
				})
			});
			return r;

		});

		const runAction = (a:any) => {
			if(a.fn){
				a.fn();
			}
		};
		
		

		return {
			actions,
			buttonSize,
			runAction
		};
	}
});

